import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import { config } from "../utils/constants"; // Assuming you use config for URLs

const VideoRedirect = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const version = queryParams.get("v");

  useEffect(() => {
    const label =
      version === "2"
        ? "Intro video female version"
        : "Intro video male version";

    ReactGA.event({
      category: "engagement",
      action: "video viewed",
      label: label,
    });

    // Redirect after a short delay (optional)
    setTimeout(() => {
      window.location.href = `${config.url.REACT_APP_API_URL}/start/hair-health-assessment/`;
    }, 300); // 300ms delay for tracking to register
  }, [version]);

  return (
    <div className="text-center py-5">
      <p>Redirecting you to your hair health assessment...</p>
    </div>
  );
};

export default VideoRedirect;
